import { cn } from "@/lib/utils";

type SchedoraLogoProps = {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  iconOnly?: boolean;
};

export function SchedoraLogo({
  className,
  iconClassName,
  textClassName,
  iconOnly = false,
}: SchedoraLogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <SchedoraMark className={iconClassName} />
      {!iconOnly && (
        <span className={cn("font-heading font-semibold text-foreground", textClassName)}>
          Schedora
        </span>
      )}
    </div>
  );
}

type SchedoraMarkProps = {
  className?: string;
};

export function SchedoraMark({ className }: SchedoraMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      aria-hidden="true"
      className={cn("h-6 w-6 text-primary", className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.821 10.667C32.253 10.667 33.232 12.111 33.415 13.76L34.31 21.813C34.646 24.837 36.654 27.33 39.297 27.939L47.006 29.715C48.622 30.087 49.953 31.183 49.953 32.667C49.953 34.151 48.622 35.247 47.006 35.619L39.297 37.395C36.654 38.004 34.646 40.497 34.31 43.521L33.415 51.573C33.232 53.223 32.253 54.667 30.821 54.667C29.389 54.667 28.41 53.223 28.227 51.573L27.332 43.521C26.995 40.497 24.987 38.004 22.345 37.395L14.636 35.619C13.02 35.247 11.688 34.151 11.688 32.667C11.688 31.183 13.02 30.087 14.636 29.715L22.345 27.939C24.987 27.33 26.995 24.837 27.332 21.813L28.227 13.76C28.41 12.111 29.389 10.667 30.821 10.667Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M50 10V22" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M44 16H56" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
